import {httpWithLoader} from '@/http-common';
import {handleError} from "./common";

const state = () => ({
    demandedPkList: [],
    // workFunctionsList: [],
    curPKId: null
});

const mutations = {
    SET_DEMANDED_LIST(state, demandedList) {
        demandedList.forEach(el => {
            if (el.docs != null) {
                el.docs = JSON.parse(el.docs);
            }
        })
        state.demandedPkList = demandedList;
    },
    SET_IS_DEMANDED(state, qualificationDemanded) {
        const index = state.demandedPkList.findIndex(el => el.id === qualificationDemanded.id)
        let qualification = state.demandedPkList[index];
        qualification.is_demanded = qualificationDemanded.is_demanded;
    },
/*    SET_WORK_FUNCTIONS_LIST(state, workFunctionsList) {
        state.workFunctionsList = workFunctionsList;
    },*/
};

const actions = {
    // Получить Список ПК
    async LOAD_DEMANDED_PK({commit, rootState}) {
        await httpWithLoader.get(`/qualifications`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('SET_DEMANDED_LIST', response.data);
            })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },
    async TO_DEMANDED({commit, rootState}, q) {
        return await httpWithLoader.post(`/qualifications/${q}/demanded`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }

        }).then((response) => {
            commit('SET_IS_DEMANDED', response.data);
        })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },
    async MARK_DEMANDED({ commit, rootState }, pkId) {
        await httpWithLoader.post(`/qualifications/${ pkId }/mark_demanded`,  {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        }).then((response) => {
            commit('SET_IS_DEMANDED', response.data);
        })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },
    async MARK_NOT_DEMANDED({ commit, rootState }, pkId) {
        await httpWithLoader.post(`/qualifications/${ pkId }/mark_not_demanded`,  {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        }).then((response) => {
            commit('SET_IS_DEMANDED', response.data);
        })
            .catch((reject) => {
                handleError(reject, commit)
            });
    },
    /*async LOAD_ALL_WORK_FUNCTIONS({ commit, rootState }) {
        if (this.workFunctionsList == undefined) {
            await httpWithLoader.get(`/work-functions`, {
                headers: {
                    'Authorization': `bearer ${rootState.tokens.accessToken}`
                }
            })
                .then((response) => {
                    commit('SET_WORK_FUNCTIONS_LIST', response.data);
                })
                .catch((reject) => {
                    handleError(reject, commit)
                });
        }
    },*/
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
